import { isPlatformBrowser } from '@angular/common'
import { PLATFORM_ID, inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'

import { map } from 'rxjs'

import { AuthService } from '../services/auth/auth.service'

export const redirectLoginGuard: CanActivateFn = (_route, state) => {
  const platformId = inject(PLATFORM_ID)
  const authService = inject(AuthService)
  const router = inject(Router)

  const targetUrl = state.url

  if (!isPlatformBrowser(platformId)) {
    return true
  }

  // Allow access to login page unconditionally
  if (targetUrl.includes('/auth/login')) {
    return true
  }

  return authService.waitForAuthCheckCompletion().pipe(
    map(() => {
      if (!authService.isAuthenticated()) {
        return router.parseUrl(
          `/auth/login?returnUrl=${encodeURIComponent(targetUrl)}`
        )
      }

      return true
    })
  )
}
